import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.alabaster,
  h1Color: colors.ash,
  h2Color: colors.ash,
  paraColor: colors.slateGreen,
  anchorColor: colors.pine
};
export default richText;